const RUNTIME_ENV = (window && window.APP_RUNTIME_ENV_VARIABLES) || {}

const env = {
  ...process.env,
  ...RUNTIME_ENV,
}

export default env
